import { Injectable } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';

import { environment } from '../../../environments/environment';

@Injectable()
export class BaseAddressInterceptor implements HttpInterceptor {
  constructor(public platformLocation: PlatformLocation) { }

  getApiUrl(url: string): string {
    const baseAddress = environment.baseAddress.trim();
    let apiUrl = url;
    if (baseAddress && baseAddress !== "/" && url.indexOf('/api/') === 0) {
      const baseHref = this.platformLocation.getBaseHrefFromDOM().trim();
      if (baseHref && baseHref !== "/") {
        apiUrl = environment.baseAddress + '/' + baseHref + url;
      } else {
        apiUrl = environment.baseAddress + url;
      }
    }
    return apiUrl;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const baseAddress = environment.baseAddress.trim();
    if (baseAddress && baseAddress !== "/" && req.url.indexOf('/api/') === 0) {
      const url = this.getApiUrl(req.url);
      const apiReq = req.clone({ url: url });
      return next.handle(apiReq);
    }
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/BaseAddressInterceptor.ts